import type { ComponentProps } from 'react';
import type { Step } from 'react-joyride';

import { Joyride } from 'react-joyride';

import useDarkMode from '../../hooks/useDarkMode';

import TutorialBeacon from './TutorialBeaceon/TutorialBeacon';
import TutorialTooltip from './TutorialTooltip/TutorialTooltip';

export type TutorialStep = Step & {
  page: string;
  target?: string;
  testId?: string;
};

interface TutorialProps extends Omit<
  ComponentProps<typeof Joyride>,
  'tooltipComponent' | 'beaconComponent'
> {
  /**
   * Tutorial steps with testId
   */
  steps: TutorialStep[];
  /**
   * Custom test ID for the component
   */
  testId?: string;
}

const Tutorial = (props: TutorialProps) => {
  const [darkMode] = useDarkMode();

  return (
    <Joyride
      tooltipComponent={TutorialTooltip}
      beaconComponent={TutorialBeacon}
      continuous={true}
      options={{
        arrowColor: darkMode ? 'rgb(51, 65, 85)' : '#FFFFFF',
        overlayColor: 'rgb(0 0 0 / 46%)',
        zIndex: 1000,
        showProgress: true,
        scrollOffset: 70,
      }}
      {...props}
    />
  );
};

export default Tutorial;
